import axios from "axios";

// Abre um PDF autenticado (relatorio de campo / RIL) sem expor o endpoint publico.
// Abre a janela sincronamente (evita bloqueio de popup), busca o PDF como blob
// (o interceptor global injeta o access-token) e aponta a janela pro blob.
// `guard` (opcional, async): checagem feita com a janela já aberta; se devolver false, fecha.
export default async function openAuthenticatedPdf(url, guard) {
  const win = window.open("", "_blank");
  try {
    if (guard && !(await guard())) {
      if (win) win.close();
      return false;
    }
    const { data } = await axios.get(url, { responseType: "blob" });
    const blobUrl = URL.createObjectURL(data);
    if (win) {
      win.location.href = blobUrl;
    } else {
      window.open(blobUrl, "_blank");
    }
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    return true;
  } catch (error) {
    if (win) win.close();
    throw error;
  }
}
